import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

export function Navigation() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bg-white border-b border-border-gray sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img
                src="/logo.svg"
                alt="Pairing.dev"
                className="h-8 w-auto"
              />
              <span className="ml-2 text-xl font-bold text-dark-blue">
                Pairing.dev
              </span>
            </Link>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`transition-colors ${isActive('/') ? 'text-primary-blue font-semibold' : 'text-text-dark hover:text-primary-blue'}`}
            >
              Home
            </Link>
            <Link
              to="/casestudies"
              className={`transition-colors ${isActive('/casestudies') ? 'text-primary-blue font-semibold' : 'text-text-dark hover:text-primary-blue'}`}
            >
              Case Studies
            </Link>
            <Link
              to="/about"
              className={`transition-colors ${isActive('/about') ? 'text-primary-blue font-semibold' : 'text-text-dark hover:text-primary-blue'}`}
            >
              About
            </Link>
            <Link
              to="/book"
              className="bg-primary-blue text-white px-6 py-2 rounded-md hover:bg-dark-blue transition-colors font-medium"
            >
              Work with us
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              type="button"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-text-dark hover:text-primary-blue p-2"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden border-t border-border-gray">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <Link
              to="/"
              onClick={() => setIsMenuOpen(false)}
              className={`block px-3 py-2 rounded-md text-base font-medium ${isActive('/') ? 'text-primary-blue bg-bg-gray-light' : 'text-text-dark hover:text-primary-blue hover:bg-bg-gray-light'}`}
            >
              Home
            </Link>
            <Link
              to="/casestudies"
              onClick={() => setIsMenuOpen(false)}
              className={`block px-3 py-2 rounded-md text-base font-medium ${isActive('/casestudies') ? 'text-primary-blue bg-bg-gray-light' : 'text-text-dark hover:text-primary-blue hover:bg-bg-gray-light'}`}
            >
              Case Studies
            </Link>
            <Link
              to="/about"
              onClick={() => setIsMenuOpen(false)}
              className={`block px-3 py-2 rounded-md text-base font-medium ${isActive('/about') ? 'text-primary-blue bg-bg-gray-light' : 'text-text-dark hover:text-primary-blue hover:bg-bg-gray-light'}`}
            >
              About
            </Link>
            <Link
              to="/book"
              onClick={() => setIsMenuOpen(false)}
              className="block px-3 py-2 rounded-md text-base font-medium bg-primary-blue text-white hover:bg-dark-blue"
            >
              Work with us
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
